import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';
import { FilterDashboardGenreSimplifie } from '../types';

import Filter from './Filter/Filter';

interface DashboardHeaderProps {
  totalCount: number;
  refreshDashboard: () => void;
  filter: Partial<FilterDashboardGenreSimplifie>;
  setFilter: (value: Partial<FilterDashboardGenreSimplifie>) => void;
}

export function DashboardHeader({
  totalCount,
  refreshDashboard,
  filter,
  setFilter,
}: DashboardHeaderProps): React.ReactElement {
  const modalCreation = useModal();
  const pluralMarqueIfNecessary = totalCount > 1 ? 's' : '';

  const countString = `${totalCount} genre${pluralMarqueIfNecessary} simplifié${pluralMarqueIfNecessary} trouvé${pluralMarqueIfNecessary}`;

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={modalCreation.open}
        >
          Créer un genre simplifié
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>

      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
